/** Notificações in-app e o registro de push (device nativo / web push). */
import { z } from "zod";
import { devicePlatform, notificationType, pushProvider } from "../enums.js";
import { cursorPage, uuid } from "./common.js";

/* ---------- Notificacoes / push ---------- */
export const registerDeviceInput = z.object({
  installationId: z.string().min(8).max(128),
  platform: devicePlatform,
  provider: pushProvider,
  pushToken: z.string().min(8),
});

export const notification = z.object({
  id: uuid,
  type: notificationType,
  title: z.string(),
  body: z.string(),
  conversationId: uuid.nullable(),
  readAt: z.string().nullable(),
  createdAt: z.string(),
});
export type Notification = z.infer<typeof notification>;

export const notificationListInput = cursorPage.extend({
  tipo: notificationType.optional(),
});
export type NotificationListInput = z.infer<typeof notificationListInput>;

export const pushDiagnostics = z.object({
  permission: z.enum(["granted", "denied", "prompt", "unsupported"]),
  tokenActive: z.boolean(),
  tokenTail: z.string().nullable(),
  quietHours: z.object({ enabled: z.boolean(), from: z.string(), to: z.string() }).nullable(),
  lastSuppression: z.object({ reason: z.string(), at: z.string() }).nullable(),
  lastDeliveryAt: z.string().nullable(),
});
export type PushDiagnostics = z.infer<typeof pushDiagnostics>;

export const webPushSubscribeInput = z.object({
  subscription: z.unknown(),
});
